<app-toast></app-toast>
<app-loader></app-loader>
<div class="router-container" [class.loading]="loaderService.loading() || sidenavService.opened()">
  <router-outlet />
</div>
